// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Minimum distinct slots a student should see within horizon (1-to-1 / small groups)
 */
export type EventKindCoverageMinOptionsPerStudent = number | null;
